var _rect, _rect2, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEx1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#F44336"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(15 15)",
    fill: "#F44336"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7497 18.3333C33.7497 17.6429 34.3093 17.0833 34.9997 17.0833C44.8948 17.0833 52.9163 25.1048 52.9163 34.9999C52.9163 44.895 44.8948 52.9166 34.9997 52.9166C25.1046 52.9166 17.083 44.895 17.083 34.9999C17.083 29.9882 19.1424 25.4552 22.458 22.2049C22.9509 21.7216 23.7424 21.7295 24.2256 22.2225C24.7089 22.7155 24.701 23.5069 24.2081 23.9902C21.3524 26.7896 19.583 30.687 19.583 34.9999C19.583 43.5143 26.4853 50.4166 34.9997 50.4166C43.5141 50.4166 50.4163 43.5143 50.4163 34.9999C50.4163 26.4855 43.5141 19.5833 34.9997 19.5833C34.3093 19.5833 33.7497 19.0236 33.7497 18.3333Z",
    fill: "url(#paint0_linear_255_750)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7497 23.3333C33.7497 22.6429 34.3093 22.0833 34.9997 22.0833C42.1334 22.0833 47.9163 27.8662 47.9163 34.9999C47.9163 42.1336 42.1334 47.9166 34.9997 47.9166C27.866 47.9166 22.083 42.1336 22.083 34.9999C22.083 34.3096 22.6427 33.7499 23.333 33.7499C24.0234 33.7499 24.583 34.3096 24.583 34.9999C24.583 40.7529 29.2467 45.4166 34.9997 45.4166C40.7526 45.4166 45.4163 40.7529 45.4163 34.9999C45.4163 29.247 40.7526 24.5833 34.9997 24.5833C34.3093 24.5833 33.7497 24.0236 33.7497 23.3333Z",
    fill: "url(#paint1_linear_255_750)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9997 27.0833C34.3093 27.0833 33.7497 27.6429 33.7497 28.3333C33.7497 29.0236 34.3093 29.5833 34.9997 29.5833C37.9912 29.5833 40.4163 32.0084 40.4163 34.9999C40.4163 37.9915 37.9912 40.4166 34.9997 40.4166C34.3093 40.4166 33.7497 40.9762 33.7497 41.6666C33.7497 42.3569 34.3093 42.9166 34.9997 42.9166C39.3719 42.9166 42.9163 39.3722 42.9163 34.9999C42.9163 30.6277 39.3719 27.0833 34.9997 27.0833Z",
    fill: "url(#paint2_linear_255_750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_255_750",
    x1: 34.9997,
    y1: 17.0833,
    x2: 34.9997,
    y2: 52.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_255_750",
    x1: 34.9997,
    y1: 17.0833,
    x2: 34.9997,
    y2: 52.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_255_750",
    x1: 34.9997,
    y1: 17.0833,
    x2: 34.9997,
    y2: 52.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.46
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEx1);
export default __webpack_public_path__ + "static/media/ex1.45abdf9e224824a923aa4bd1f0383d27.svg";
export { ForwardRef as ReactComponent };